module.exports = __webpack_public_path__ + "img/pop_huang@2x.817b6c56.png";